import { useContext } from 'react'
import { ReferralsContext } from './context'

export function useReferralsContext() {
  const context = useContext(ReferralsContext)

  if (context === undefined)
    throw Error('Must be descendant of ReferralsContextProvider')

  return context
}
